export class PropertyType {
    public id: string;
    public name: string;
    public productSkillsetId : string;
    public propertyField: string;
    public isRetail: boolean;
}

export class AddPropertyType {
    public name: string;
    public productSkillsetId: string;
    public propertyField: string;
    public isRetail: boolean;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type.model.ts